import React, { useState } from 'react';

import styled from '@emotion/styled';

import StatusGraph from '../../../components/StatusGraph/StatusGraph';
import VerticalStatusGraph from '../../../components/StatusGraph/VerticalStatusGraph';
import { ITrackPackageResponse } from '../../../models/trackPage/trackPackage.model';
import StatusCell from '../../../components/Card/StatusCell';
import MoreShipmentDetails from './MoreShipmentDetails';
import { DoubleRightOutlined } from '@ant-design/icons';

interface IShippingStatus {
 trackingInfo?: ITrackPackageResponse;
}

const ShippingStatus: React.FC<IShippingStatus> = ({ trackingInfo }) => {
 const [showMoreDetails, setShowMoreDetails] = useState(false);

 return (
  <Container>
   <Row>
    <TextBar>Shipping Status</TextBar>
    <StatusCell
     data={{ status: trackingInfo?.shippingStatus }}
     statusKey='status'
     plain
    />
   </Row>
   <StatusGraph
    status={trackingInfo?.shippingStatus ?? 'PROCESSING_CLEARANCE'}
   />
   <VerticalStatusGraph
    status={trackingInfo?.shippingStatus ?? 'PROCESSING_CLEARANCE'}
   />
   <MoreDetailsToggle onClick={() => setShowMoreDetails(!showMoreDetails)}>
    More details
    <Icon isOpen={showMoreDetails}>
     <DoubleRightOutlined size={16} />
    </Icon>
   </MoreDetailsToggle>
   {showMoreDetails && <MoreShipmentDetails trackingInfo={trackingInfo} />}
  </Container>
 );
};

export default ShippingStatus;

const Container = styled.div`
 border: 1px solid ${({ theme }) => theme.palette.borderColor};
 padding: 24px;
 border-radius: 10px;
 display: flex;
 flex-direction: column;
 gap: 21px;
`;

const Row = styled.div`
 display: flex;
 align-items: center;
 gap: 12px;

 @media (max-width: 480px) {
  flex-direction: column;
 }
`;

const TextBar = styled.div`
 font-size: 18px;
 font-weight: 500;
 color: #1f2937;
`;

const MoreDetailsToggle = styled.button`
 display: flex;
 align-items: center;
 gap: 4px;
 background: none;
 border: none;
 color: #da0e29;
 font-size: 16px;
 font-weight: 500;
 cursor: pointer;
 padding: 0;
 margin-top: 12px;

 &:hover {
  opacity: 0.8;
 }
`;

interface IconProps {
 isOpen: boolean;
}

const Icon = styled.span<IconProps>`
 display: inline-block;
 transform: rotate(${({ isOpen }) => (isOpen ? '270deg' : '90deg')});
 transition: transform 0.3s ease;
`;
